import React from "react";
import { Result } from "antd";
import { btnStyle } from "../../lib/styles/styleLibrary";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import MainLayout from "../../components/MainLayout/MainLayout";
import { useHistory } from "react-router";
import Auth from "../../lib/middleware/auth";

const ErrorPage = (props) => {
	const history = useHistory();
	const isAuth = Auth.isAuthenticated();
	return (
		<>
			{isAuth ? (
				<MainLayout>
					<div tw="h-full w-full flex items-center justify-center">
						<Result
							status="404"
							title="404"
							subTitle="Sorry, the page you visited does not exist."
							extra={
								<button
									css={btnStyle}
									onClick={() => history.goBack()}>
									Return to previous
								</button>
							}
						/>
					</div>
				</MainLayout>
			) : (
				<div tw="h-screen w-full flex items-center justify-center">
					<Result
						status="404"
						title="404"
						subTitle="Sorry, the page you visited does not exist."
						extra={
							<button
								css={btnStyle}
								onClick={() => history.goBack()}>
								Return to previous
							</button>
						}
					/>
				</div>
			)}
		</>
	);
};

export default ErrorPage;
